export default __webpack_public_path__ + "static/mockup2-30a01de4b59320758de44cb30693d7d7.png";